export const softwareSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'SpaceByte Cloud',
  operatingSystem: 'Windows, macOS, Android, iOS, Web',
  applicationCategory: 'StorageApplication',
  screenshot: 'https://spacebyte.in/images/LandingImg/heroimg.webp',
  featureList: [
    'End-to-End Encryption',
    'Secure File & Folder Sharing',
    'No Bandwidth Limit',
    'Permission Control'
  ],
  url: 'https://spacebyte.in',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'INR',
    description: '25 GB Free Cloud Storage Forever',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    bestRating: '5',
    worstRating: '1',
    ratingCount: '1480',
    reviewCount: '1480',
  },
  review: [
    {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: 'Aarav Sharma',
      },
      datePublished: '2026-01-15',
      reviewBody:
        'SpaceByte is insanely fast for backing up 4K videos and raw photos in India. The 25 GB free storage is incredible.',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: '5',
        bestRating: '5',
        worstRating: '1',
      },
    },
    {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: 'Priya Patel',
      },
      datePublished: '2026-02-10',
      reviewBody:
        'Best Google Drive alternative in India with native UPI payment support and sub-15ms domestic speeds.',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: '5',
        bestRating: '5',
        worstRating: '1',
      },
    },
    {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: 'Rohan Verma',
      },
      datePublished: '2026-03-01',
      reviewBody:
        'Zero-knowledge security and uncompressed media uploads make SpaceByte the top cloud storage for content creators.',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: '5',
        bestRating: '5',
        worstRating: '1',
      },
    },
  ],
};
